<template>
  <section class="content map">

    <div class="map-filters" ref="elFilters">
      <datepicker class="form-control" language="fr" v-model="map.filters.date"
                  v-on:selected="SearchTournees"></datepicker>

      <!-- <select class="form-control" v-model="map.filters.idRonde">
        <option v-for="ronde in rondes.data" :value="ronde.meta.id">{{ ronde.nom }}</option>
      </select>

      <select class="form-control" v-model="map.filters.idAgent">
        <option v-for="agent in sortedAgents" :value="agent.meta.id">{{ `${agent.firstname} ${agent.lastname}` }}</option>
      </select> -->

      <multiselect id="ronde" class="multiselect-class" v-model="map.filters.Ronde" placeholder="Trouver une ronde"
                   label="nom"
                   track-by="id" :options="rondesSelect" :multiple="false" @select="selectRonde"
                   @remove="removeRonde"></multiselect>

      <multiselect ref="agentMultiselect" id="ronde" class="multiselect-class" v-model="map.filters.Agent"
                   placeholder="Trouver un agent" label="fullName" track-by="id" :options="agentsSelect"
                   :multiple="false" @select="selectAgent" @remove="removeAgent"></multiselect>

      <div class="buttons">

        <button type="button"
                v-on:click="search()"
                :disabled="map.searching === true || !map.filters.Agent || !map.filters.Ronde"
                class="btn btn-primary display-map">{{ map.searching ? 'Chargement...' : 'Afficher' }}
        </button>

        <button type="button"
                v-on:click="clear()"
                :disabled="!(map.result !== null || map.message !== null)"
                class="btn btn-default clear-map">Vider
        </button>

      </div>
    </div>

    <message
      :obj=map.message
      hide-mutation-type="CLEAR_MAP_MESSAGE">
    </message>

    <div class="map-wrapper">

      <div class="tournee-time" v-if="map.result !== null">
        <div class="time-item">
          <div class="mapico debut"></div>
          Début : {{ formatTime(map.result.startedAt) }}
        </div>
        <div class="time-item" v-if="map.result.finishedAt">
          <div class="mapico fin"></div>
          Fin : {{ formatTime(map.result.finishedAt) }}
        </div>
        <div class="time-item" v-if="map.result.finishedAt">
          <div class="mapico pendule"></div>
          Duréé : {{ calculateTimeDifference(map.result.startedAt, map.result.finishedAt) }}
        </div>
        <div class="time-item">
          <div class="mapico avancement"></div>
          Avancement : {{ map.result.progressPercentage }}%
        </div>
        <div class="time-item" v-if="map.result.totalPause > 0 ">
          <div class="mapico pause"></div>
          Pause : {{ formatPause(map.result.totalPause) }}
        </div>
      </div>

      <gmap-map
        ref="map"
        v-if="mounted"
        :center="center"
        :zoom="zoom"
        map-type-id="roadmap"
        :style="mapStyle">

        <gmap-marker
          v-for="m in geopassages"
          :icon="{ 'url' : 'static/img/'+getPictoForRomontees(m)+'.png'   }"
          :position="{ 'lat' : m.lat, 'lng' : m.lon }"
        ></gmap-marker>

      </gmap-map>

    </div>


  </section>
</template>

<script>
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import Message from '../../shared/Message'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Datepicker,
    Message,
    Multiselect,
  },
  data: function () {
    return {
      agentsSelect: [],
      rondesSelect: [],
      mounted: false,
      currentMidx: null,
      selectedAgent: null,
      selectedRonde: null,
    }
  },
  computed: {
    ...mapState([
      'map',
      'rondes',
    ]),
    geopassages: function () {
      var map = this.$store.state.map
      if (map.result === null) {
        return []
      } else {
        return map.result.remonteeGPSs
      }
    },
    center: function () {
      var map = this.$store.state.map
      if (map.result === null) {
        return {lat: 45.75801, lng: 4.8330158}
      } else if (map.result.remonteeGPSs.length === 0) {
        return {lat: 45.75801, lng: 4.8330158}
      } else {
        return {
          lat: map.result.remonteeGPSs[0].lat,
          lng: map.result.remonteeGPSs[0].lon,
        }
      }
    },
    zoom: function () {
      console.log('Ayooooooooooooo')
      var map = this.$store.state.map
      if (map.result === null) {
        return 13
      } else if (map.result.remonteeGPSs.length === 0) {
        return 14
      } else {
        return 15
      }
    },
    mapStyle: function () {
      const h = document.body.clientHeight - this.$refs.elFilters.offsetTop - this.$refs.elFilters.clientHeight - 40
      return 'width: 100%; height: ' + h + 'px'
    },
  },
  updated: function () {
    console.log('updaaaaaaaaaaaaated')
    var map = this.$store.state.map
    if (map.result !== null && map.result.remonteeGPSs.length > 0) {
      console.time('Calculating map bounds')
      var bounds = new google.maps.LatLngBounds() // eslint-disable-line no-undef
      map.result.remonteeGPSs.forEach(function (geo) {
        bounds.extend({lat: geo.lat, lng: geo.lon})
      })
      this.$refs.map.fitBounds(bounds)
      console.timeEnd('Calculating map bounds')
    }
    /*         if (this.$store.getters.sortedAgents && this.rondes.data && !this.$store.state.map.searching) {
              this.reorganizeAgents()
              this.reorganizeRondes()
              console.log('Updating Multiselect options ...')
            } */
  },
  mounted: async function () {
    console.log('coucou')
    this.mounted = true
    await this.$store.dispatch('fetchAgentsV2')
    await this.$store.dispatch('fetchRondesV2')
    this.getTournees()

  },
  beforeDestroy () {
    console.log('Leaving the page - Perform cleanup here')
    if (this.map.result == null) {
      this.map.filters.Agent == null
      this.map.filters.Ronde == null
    }
    /*     this.selectedRonde = null
        this.selectedAgent = null
        this.map.result = null */
  },
  methods: {
    search: function () {
      this.$store.dispatch('searchTournee', {
        date: this.$store.state.map.filters.formattedDate,
        idRonde: this.map.filters.Ronde.id,
        idAgent: this.map.filters.Agent.id
      })
    },
    clear: function () {
      this.map.filters.Ronde = null
      this.map.filters.Agent = null
      this.map.result = null
      // this.getTournees()
    },
    selectRonde: function (selectedOption) {
      this.map.filters.Ronde = selectedOption
      console.log('selected ronde ::: ', this.map.filters.Ronde)
      this.reorganizeAgents()
    },
    removeRonde: function () {
      this.agentsSelect = _.cloneDeep(this.map.agents)
      this.rondesSelect = _.cloneDeep(this.map.rondes)
      this.map.filters.Ronde = null
      if (this.map.filters.Agent) {
        this.reorganizeRondes()
      }
    },
    reorganizeAgents: function () {
      this.agentsSelect = []
      let agent = this.$store.state.map.agents.find(a => a.id === this.map.filters.Ronde.agent_id)
      this.agentsSelect.push(agent)
    },
    reorganizeRondes: function () {
      this.rondesSelect = []
      let ronde = this.$store.state.map.rondes.find(r => r.agent_id === this.map.filters.Agent.id)
      this.rondesSelect.push(ronde)
    },
    selectAgent: function (selectedOption) {
      this.map.filters.Agent = selectedOption
      console.log('selected agent ::: ', this.map.filters.Agent)
      this.reorganizeRondes()
    },
    removeAgent: function () {
      this.agentsSelect = _.cloneDeep(this.map.agents)
      this.rondesSelect = _.cloneDeep(this.map.rondes)
      this.map.filters.Agent = null
      if (this.map.filters.Ronde) {
        this.reorganizeAgents()
      }
    },
    SearchTournees: async function (date) {
      if (!date) {
        date = this.$store.state.map.filters.date
      }
      var year = date.getFullYear()
      var month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      var day = String(date.getDate()).padStart(2, '0')

      var formattedDate = `${year}-${month}-${day}`

      this.map.filters.formattedDate = formattedDate
      await this.$store.dispatch('searchTourneeOnly', {
        date: formattedDate
      })
      this.map.filters.Ronde = null
      this.map.filters.Agent = null
      this.map.result = null
      this.agentsSelect = _.cloneDeep(this.map.agents)
      this.rondesSelect = _.cloneDeep(this.map.rondes)
    },
    getTournees: async function (date) {

      if (this.map.result == null) {
        this.SearchTournees()
      }
      this.agentsSelect = _.cloneDeep(this.map.agents)
      this.rondesSelect = _.cloneDeep(this.map.rondes)
    },
    getPictoForRomontees: function (marker) {
      var ico
      if (marker.type === 'DEBUT_DE_SERVICE') {
        ico = 'map-debut'
      } else if (marker.type === 'FIN_DE_SERVICE') {
        ico = 'map-fin'
      } else {
        ico = 'marker'
      }
      return ico
    },
    calculateTimeDifference (dateDebut, dateFin) {
      const d1 = new Date(dateDebut)
      const d2 = new Date(dateFin)

      // Calculate the time difference in milliseconds
      const timeDiff = Math.abs(d2 - d1)

      // Convert milliseconds to hours and minutes
      const hours = Math.floor(timeDiff / (60 * 60 * 1000))
      const minutes = Math.floor((timeDiff % (60 * 60 * 1000)) / (60 * 1000))

      return this.formatedTime(hours, minutes)
    },
    formatedTime (hours, minutes) {
      return `${this.pad(hours)}H${this.pad(minutes)}`
    },
    formatTime (date) {
      const dateObject = new Date(date)

      // Get hours and minutes
      const hours = this.pad(dateObject.getHours())
      const minutes = this.pad(dateObject.getMinutes())

      // Format the result as "HH:MM"
      return `${hours}H${minutes}`
    },
    formatPause (time) {
      // Calculate hours, minutes, and seconds
      const hours = Math.floor(time / (1000 * 60 * 60))
      const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((time % (1000 * 60)) / 1000)

      // Format the result as "hh:mm:ss"
      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`
    },
    pad (value) {
      return value < 10 ? `0${value}` : value
    }
  },
}
</script>

<style lang="scss">

@import '../../../scss/variables';

.map-wrapper {
  position: relative;

  .tournee-time {
    position: absolute;
    z-index: 10;
    top: 45px;
    left: 10px;
    background-color: white;
    padding: 10px;

    .time-item {
      text-transform: uppercase;
      line-height: 24px;
      height: 24px;

      .mapico {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;
        color: $suez-blue;

        &.debut {
          background-image: url('/static/img/map-debut.png');
        }

        &.fin {
          background-image: url('/static/img/map-fin.png');
        }

        &.pendule {
          background-image: url('/static/img/time.svg');
        }

        &.pause {
          background-image: url('/static/img/cup-of-hot-chocolate.svg');
        }
      }
    }
  }
}

.content.map {
  height: 100%;
}

.map-filters {
  .form-control {
    display: inline-block;
    width: 20%;
    min-width: 160px;
  }

  .buttons {
    display: inline-block;
    vertical-align: top;
    margin-top: 5px;

    button.display-map {
      margin-left: 5px;
    }

    button.clear-map {
    }
  }

  margin-bottom: 20px;
}

.vdp-datepicker.form-control {
  -webkit-appearance: menulist-button;
  -moz-appearance: menulist-button;
  appearance: menulist-button;
  width: 180px;
  padding: 0;
  margin: 0;

  input {
    background-image: url('/static/img/dropdown-icon.png');
    background-repeat: no-repeat;
    background-position: right center;
    border: none !important;
    padding: 5px;
    width: 98%;
    margin: 2px;
  }
}

.multiselect-class {
  width: 20%;
  min-width: 200px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// Map.vue?5da75d72